"use strict";window.Marko = {
  Component: function () {}
};